import { appBarPropMixin } from '@/mixins/appBarPropMixin';

export const subAppBarPropMixin = {
  mixins: [appBarPropMixin],
  computed: {
    appBarTopProps () {
      return {
        ...this.appBarProps,
        id: 'sub-top-app-bar',
        height: 100,
        style: {
          transform: this.isScrollingUp && this.currentScroll > 60 && 'translateY(-100px)' || 'translateY(0px)',
          right: null,
          left: null,
        },
        class: {
          ...this.appBarProps.class,
        },
      };
    },
    bottomBarHideOnScroll () {
      return this.documentHeight > this.currentScroll + this.windowHeight + 80 && this.currentScroll > 120;
    },
  },
  methods: {
    initForIos () {
      this.$nextTick(() => {
        const scroll = this.currentScroll;

        // ios safari 100vh 버그때문에..
        this.$vuetify.goTo(scroll + 101, {duration: 0}).then(() => {
          // this.$vuetify.goTo(scroll, {duration: 0});
        });
      });
    },
  },
};